import React from "react";
import { CRYPTO_CURRENCY_SYMBOL } from "../../common/constants";
import { DappContextProvider } from "../../contexts/MintContext";

export function WalletConnected(): React.ReactElement {
  const { userAddress, userBalance } = React.useContext(DappContextProvider);
  const truncatedAddress = `${userAddress?.substring(0,3)}...${userAddress?.substring(userAddress.length-3)}`;
  const roundedBalance = Math.round(userBalance *100)/100;
  return (
    <div className="connection-message"> 
      {`${truncatedAddress} | ${roundedBalance}`}
      <img 
        className={"crypto-symbol"}
        src= {CRYPTO_CURRENCY_SYMBOL}
        alt={"crypto-symbol"}
      />
    </div>
  );
}
